module.exports = __webpack_public_path__ + "img/PL08110.d83dd542.png";